// 3p
import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';

// Fp
import Router from './Router';
import './index.css';
import 'tachyons/css/tachyons.css';
import 'draft-js/dist/Draft.css';
import configureStore from './store/configure-store';

const store = configureStore();

import {SET_AUTH_ADAPTER, SET_DB_ADAPTER} from './constants';
import {Auth, Db} from './adapters/firebase';

store.dispatch({ type: SET_AUTH_ADAPTER, adapter: new Auth()});
store.dispatch({ type: SET_DB_ADAPTER, adapter: new Db()});

ReactDOM.render(
  <Provider store={store}>
    <Router />
  </Provider>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/